module.exports = __webpack_public_path__ + "img/logo.844471dc.png";